import {
     LOAD_DOWNLOAD_START,
     LOAD_DOWNLOAD_DONE,
     SHOW_QR_MODAL,
     HIDE_QR_MODAL
    
    } from 'constants/downloadQr';
   
    const initialState = {
        visible:false
      
    };
    export default function downloadQr(state = initialState,actions){
          console.log(state,actions)
        switch(actions.type){
            case SHOW_QR_MODAL:
                return {...state,visible:true};
            case HIDE_QR_MODAL:
                return {...state,visible:false};
            default:
                return state;
        }
    } 


// WEBPACK FOOTER //
// ./src/reducer/downloadQr.js